
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

function equal (value1, value2) {
  return String(value1) === String(value2);
}

function trimExtraChar (value, _char, regExp) {
  let index = value.indexOf(_char);
  let prefix = '';

  if (index === -1) {
    return value;
  }

  if (_char === '-' && index !== 0) {
    return value.slice(0, index);
  }

  if (_char === '.' && value.match(/^(\.|-\.)/)) {
    prefix = index ? '-0' : '0';
  }

  return prefix + value.slice(0, index + 1) + value.slice(index).replace(regExp, '');
}

/**
 * 格式化数据
 * @param value 值
 * @param allowDot 是否允许小数
 * @param allowMinus 的hi否允许负数
 */
function _formatNumber (value, allowDot, allowMinus) {
  if (allowDot === void 0) {
    allowDot = true;
  }

  if (allowMinus === void 0) {
    allowMinus = true;
  }

  if (allowDot) {
    value = trimExtraChar(value, '.', /\./g);
  } else {
    value = value.split('.')[0];
  }

  if (allowMinus) {
    value = trimExtraChar(value, '-', /-/g);
  } else {
    value = value.replace(/-/, '');
  }

  let regExp = allowDot ? /[^0-9.]/g : /[^0-9]/g;
  return value.replace(regExp, '');
}

@Component({
  name: 'StepperTemp'
})
export default class StepperTemp extends Vue {
  @Prop({ default: null }) value!: number | string;
  @Prop({ default: 1 }) min!: number | string;
  @Prop({ default: Infinity }) max!: number | string;
  @Prop({ default: 1 }) step!: number | string;
  @Prop({ default: 1 }) defaultValue!: number | string;
  @Prop({ default: true }) allowEmpty!: boolean;
  @Prop({ default: false }) asyncChange!: boolean;
  @Prop({ default: false }) disableInput!: boolean;
  @Prop({ default: false }) showLimitText!: boolean; // tips是否需要展示
  @Prop({ default: '不能超过最小起订量' }) minTips!: string; // 小于最小值提示
  @Prop({ default: '不能超过最大限订量' }) maxTips!: string; //大于最大值提示
  @Prop({ default: 'icon-tianjia' }) plusIcon!: string; // +图标
  @Prop({ default: 'icon-minus' }) minusIcon!: string; // -图标
  @Prop({ default: false }) isActivity!: boolean; // 是否处于活动
  @Prop({ default: false }) bordered!: boolean;

  currentValue = this.value

  get minusDisabled () {
    return this.currentValue <= +this.min;
  }

  get plusDisabled () {
    return this.currentValue >= +this.max;
  }

  @Watch('value')
  changeValue (val) {
    if (!equal(val, this.currentValue)) {
      this.currentValue = this.format(val);
    }
  }

  @Watch('currentValue')
  changeCurrentValue (val) {
    this.$emit('input', val);
    this.$emit('change', val);
  }

  emitChange (value) {
    if (this.asyncChange) {
      this.$emit('input', value);
      this.$emit('change', value);
    } else {
      this.currentValue = value;
    }
  }

  formatNumber (value) {
    return _formatNumber(String(value), false, false);
  }

  format (value) {
    if (this.allowEmpty && value === '') {
      return value;
    }

    value = this.formatNumber(value); // format range

    value = value === '' ? 0 : +value;
    value = isNaN(value) ? this.min : value;
    if (this.showLimitText) {
      if (value > this.max) {
        this.$toast(this.maxTips)
      }
      if (value < this.min) {
        this.$toast(this.minTips)
      }
    }
    value = Math.max(Math.min(Number(this.max), value), Number(this.min));
    return value;
  }

  addNumber (num1, num2) {
    let cardinal = Math.pow(10, 10);
    return Math.round((num1 + num2) * cardinal) / cardinal;
  }

  plusHandle (e:Event) {
        if (this.plusDisabled) {
      return
    }
    let diff = +this.step;
    let value = this.format(this.addNumber(+this.currentValue, diff));
    this.currentValue = value;
    this.$emit('input', value);
    this.$emit('change', value);
    this.$emit('plus', value, e);
  }

  minusHandle () {
    if (this.minusDisabled) {
      this.$toast(this.minTips)
      return
    }
    let diff = -this.step;
    let value = this.format(this.addNumber(+this.currentValue, diff));
    this.currentValue = value;
    this.$emit('input', value);
    this.$emit('change', value);
    this.$emit('minus', value);
    setTimeout(() => {
      this.$emit('show', false)
    }, 100)
  }

  onBlur (event) {
    let value = this.format(event.target.value);
    if (value % Number(this.step)) {
      this.$toast('订购数量需为商品起售量的倍数')
      value = this.step
    }
    event.target.value = value;
    this.currentValue = value;
    this.$emit('input', value);
    this.$emit('blur', value);
    this.$emit('show', false)
  }

  onInput (val) {
    this.$emit('show', true)
    let formatted = this.formatNumber(val); // limit max decimal length

    if (!equal(val, formatted)) {
      val = formatted;
    } // prefer number type

    if (formatted === String(+formatted)) {
      formatted = +formatted;
    }
    this.emitChange(formatted);
  }

}
